import VisibilityIcon from "@mui/icons-material/Visibility";
import { MenuItem } from "@mui/material";

import { useAuth } from "@/providers";
import { useSystemUser } from "@/providers/auth/hooks";
import { FileRecord } from "@/shared/domain/files";
import { useOrg } from "@/shared/domain/orgs/hooks";

interface ViewAsOrgMenuItemProps {
  fileRecord: FileRecord;
  onClick: () => void;
}

export function ViewAsOrgMenuItem({
  fileRecord,
  onClick,
}: ViewAsOrgMenuItemProps) {
  const { setCurrentOrganization } = useAuth();
  const { isSystemUser } = useSystemUser();

  // Fetch the organization data using the file's orgId
  const orgQuery = useOrg(isSystemUser ? fileRecord.org_id : undefined);
  const targetOrg = orgQuery.data;

  // Don't render if we don't have org data
  if (!targetOrg) {
    return null;
  }

  const handleClick = () => {
    setCurrentOrganization(targetOrg);
    onClick();
  };

  return (
    <MenuItem onClick={handleClick}>
      <VisibilityIcon
        style={{ width: "1rem", height: "1rem", marginRight: "0.75rem" }}
      />
      <span
        style={{
          maxWidth: "18ch",
          overflow: "hidden",
          textOverflow: "ellipsis",
          whiteSpace: "nowrap",
        }}
        title={targetOrg.name}
      >
        View as &quot;{targetOrg.name}&quot;
      </span>
    </MenuItem>
  );
}
